// Fallback estático para la sección "El Equipo". Se usa si la llamada a
// /api/directory falla. Los campos siguen el formato legacy (description como
// string separado por comas, location como texto libre, tags como roles); la
// función flattenStatic en ./adaptStaff los normaliza al formato consumido por
// TeamSection.

const teamMembersStatic = [
  {
    name: "Miguel Ángel",
    position: "CEO & FOUNDER",
    description: "T.S. Dietética, Maestría en Química Industrial, Máster en alimentación consciente, Coaching en Neurociencia, Técnico monitor de Atletismo, Máster en Coaching Deportivo",
    tags: ["Dirección", "Consulta Dietética"],
    image: "/assets/images/team-member/miguel-a.jpg",
    location: "Alcalá del Río, Burguillos, La Rinconada"
  },
  {
    name: "José María",
    position: "COO",
    description: "Certificado Protección de datos y garantía de los derechos digitales, Grado en Marketing, T.S. Gestión Comercial y Marketing, T.S. Dietética, C. Nutrición Sanitaria, C.S. Nutrición y herbodiética",
    tags: ["Dirección", "Consulta Dietética"],
    image: "/assets/images/team-member/jose-maria.jpeg",
    location: "La Macarena, Pino Montano"
  },
  {
    name: "Jesús",
    position: "Gestor y Abogado",
    description: "Licenciado en Derechos Laborales, Licenciado en Derecho, Licenciado en Administración y Dirección de Empresas",
    tags: ["Legal", "Fiscal"],
    image: "/assets/images/team-member/jesus.jpg"
  },
  {
    name: "Norberto José",
    position: "Consulta psicología",
    description: "Graduado en Psicología, Máster en Psicología General Sanitaria, Máster en Intervención y Mediación Familiar",
    tags: ["Psicología"],
    image: "/assets/images/team-member/norberto.jpg",
    location: "Alcalá del Río, La Macarena y Online"
  },
  {
    name: "Irene",
    position: "Community Manager",
    description: "T.S. Dietética, T.M. Auxiliar Veterinaria",
    tags: ["Redes Sociales", "Dietética"],
    image: "/assets/images/team-member/irene.jpg",
    location: "Alcalá del Río"
  },
  {
    name: "José Luis",
    position: "Responsable División de Nutrición y Dietética",
    description: "Grado en Nutrición Humana y Dietética, T.S. Dietética, C. Cineantropometría ISAK I",
    tags: ["Consulta Dietética", "Responsable División"],
    image: "/assets/images/team-member/jose-luis.jpg",
    location: "Coria del Río, San Jerónimo"
  },
  {
    name: "Ana",
    position: "Consulta dietética",
    description: "T.S. Dietética, Osteopatía, Graduada en Educación Especial",
    tags: ["Consulta Dietética"],
    image: "/assets/images/team-member/ana.jpeg",
    location: "Santa Olalla del Cala, Camas, Real de la Jara, Monesterío"
  },
  {
    name: "Javi",
    position: "Consulta dietética",
    description: "T.S. Dietética, Quiromasaje",
    tags: ["Consulta Dietética"],
    image: "/assets/images/team-member/javi.jpeg",
    location: "Arcos de la Frontera, Brenes, Cantillana, Lora del Río, Villaverde del Río, Campillos"
  },
  {
    name: "Mª José",
    position: "Consulta dietética",
    description: "T.S. Dietética, T.M Auxiliar de enfermería",
    tags: ["Consulta Dietética"],
    image: "/assets/images/team-member/m-jose.jpeg",
    location: "Carmona, Cañada Rosal, La Luisiana"
  },
  {
    name: "José Manuel",
    position: "Consulta dietética",
    description: "T.S. Dietética, T. Fitness y entrenamiento personal",
    tags: ["Consulta Dietética"],
    image: "/assets/images/team-member/jose-manuel.jpg",
    location: "Parque Alcosa, San José, Guillena, Online"
  },
  {
    name: "Israel",
    position: "Consulta dietética",
    description: "T.S. Dietética",
    tags: ["Consulta Dietética"],
    image: "/assets/images/team-member/israel.jpeg",
    location: "Gerena, Palma del Condado, Cortegana"
  },
  {
    name: "Dra. Prieto",
    position: "Colaboración",
    description: "Licenciada en Medicina y Cirugía, Especialidad en Cirugía Plástica",
    tags: ["Medicina", "Colaboración"],
    image: "/assets/images/team-member/dra-prieto.jpg",
    link: "https://www.doctoraprieto.es"
  }
];

export default teamMembersStatic;
